import { render, staticRenderFns } from "./SlotsTable.vue?vue&type=template&id=ccc7782c"
import script from "./SlotsTable.vue?vue&type=script&lang=js"
export * from "./SlotsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports